import {type PersonnelOverviewEntity} from './types/PersonnelOverviewEntity';
import {useSessionBoolean} from './useSessionBoolean';

const SESSION_KEY_PREFIX = 'personnel-overview-open';

export function usePersonnelOverviewOpen(entity: PersonnelOverviewEntity) {
  const [isOpen, setIsOpen] = useSessionBoolean(`${SESSION_KEY_PREFIX}:${entity}`);
  const toggle = () => setIsOpen(!isOpen);
  return [isOpen, toggle] as const;
}
